import { memo, useEffect, useState } from 'react';
import { Glossary, Common } from '@stockbit/ui';
import { useRouter } from 'next/router';

import { isValidTerms } from 'utils/glossary';
import { IGlossaryData, IGlossaryTerm, IMenuByTerm } from '../types';
import { DATA_CY_GLOSSARY_TERM_ITEM } from './__tests__/constant';

const { Table } = Glossary;
const { Text } = Common;

function MenuByTerm({ terms, slug, loading }: IMenuByTerm): JSX.Element {
  const router = useRouter();
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  useEffect(() => {
    const setGlossaryIndex = (): void => {
      if (!isValidTerms(terms)) {
        return;
      }

      if (!slug) {
        setSelectedIndex(0);
        return;
      }

      const glosarry = terms.find(({ alias }: IGlossaryData) => alias === slug);

      if (glosarry) {
        const newIndex = terms.findIndex(
          ({ alias }: IGlossaryData) => alias === slug,
        );
        setSelectedIndex(newIndex);
      }
    };

    setGlossaryIndex();
  }, [terms, slug]);

  const onRowClick = (term: IGlossaryTerm, index: number): void => {
    setSelectedIndex(index);
    router.push('/glossary/term/[slug]', `/glossary/term/${term.alias}`);
  };

  const glossaryTermRender = (term: string): JSX.Element => (
    <Text as="a" size="14px" data-cy={`${DATA_CY_GLOSSARY_TERM_ITEM}-${term}`}>
      {term}
    </Text>
  );

  return (
    <Table
      loading={loading && terms?.length === 0}
      dataSource={terms}
      columns={[{ dataIndex: 'name', key: 'name', render: glossaryTermRender }]}
      rowClassName={(_, index: number) =>
        (index === selectedIndex ? 'active' : '')
      }
      onRow={(record: IGlossaryTerm, rowIndex: number) => ({
        onClick: () => {
          onRowClick(record, rowIndex);
        },
      })}
    />
  );
}

export default memo(MenuByTerm);
